import { useCallback, useState } from 'react';
import { api } from '../../lib/api';

export default function useCantinaMovimientos() {
  const [movimientos, setMovimientos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [cargado, setCargado] = useState(false);

  const cargarMovimientos = useCallback(async () => {
    try {
      setCargando(true);
      setError('');

      const response = await api.get(
        '/cantina/productos/movimientos',
        {
          params: { limite: 100 },
        }
      );

      setMovimientos(
        Array.isArray(response.data) ? response.data : []
      );

      setCargado(true);
    } catch (err) {
      console.error(
        'Error cargando movimientos de Cantina:',
        err
      );

      setMovimientos([]);
      setError(
        err?.response?.data?.error ||
          'No se pudieron cargar los movimientos.'
      );
    } finally {
      setCargando(false);
    }
  }, []);

  return {
    movimientos,
    cargando,
    error,
    cargado,
    cargarMovimientos,
  };
}
